import { render } from "./DataRecordForm.vue?vue&type=template&id=46cf108c&scoped=true"
import script from "./DataRecordForm.vue?vue&type=script&lang=js"
export * from "./DataRecordForm.vue?vue&type=script&lang=js"

import "./DataRecordForm.vue?vue&type=style&index=0&id=46cf108c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cf108c"]])

export default __exports__